module.exports = __webpack_public_path__ + "img/weixing.4c8c8630.png";